@if (data?.length) {
  @for (info of data; track info) {
    <div class="info-content">
      <div class="heading">
        <label>{{ info.propertyName }}</label>
      </div>
      <div class="value">
        <p class="info">{{ info.propertyValue }}</p>
        @if (info.addressInfo) {
          <p class="info-sub">{{ info.addressInfo }}</p>
        }
        @if (info.position && (info.position === 'Company Driver' || info.position === 'Owner Operator')) {
          <p
            class="info-sub"
            >
            {{ info.position }}
          </p>
        }
        @if (info.position && info.position !== 'Company Driver' && info.position !== 'Owner Operator') {
          <p
            class="info-sub"
            >
            Other: {{ info.position }}
          </p>
        }
        @if (info?.licenseClass) {
          <p class="info-sub">{{ info?.licenseClass }}</p>
        }
        <p class="info-sub">{{ info.subPropertyValue }}</p>
        @if (info?.assignedRadius) {
          <p class="info-sub">Assigned Radius: {{ info?.assignedRadius }}</p>
        }
        @if (info?.equipmentType) {
          <p class="info-sub">Equipment Type(s): {{ info?.equipmentType }}</p>
        }
        @if (info?.reasonForLeaving) {
          <p class="info-sub">Reason for leaving: {{ info?.reasonForLeaving }}</p>
        }
        @if (info?.referenceContactName) {
          <div>
            <div class="heading-sub">
              <label>REFERENCE CONTACT</label>
            </div>
            <div class="value">
              <p class="info-sub">{{ info?.referenceContactName }}</p>
              <p class="info-sub">{{ info?.referenceContactNumber }}</p>
              <p class="info-sub">{{ info?.referenceEmail }}</p>
            </div>
          </div>
        }
        <div class="line"></div>
      </div>
    </div>
  }
}
@if (!data?.length) {
  <div class="no-record">
    <p>No Records</p>
  </div>
}
